import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DatePicker } from 'primeng/datepicker';
import { InputTextModule } from 'primeng/inputtext';
import { Select, SelectChangeEvent } from 'primeng/select';
import { StepperModule } from 'primeng/stepper';
import { FileUploadModule } from 'primeng/fileupload';
import { RadioButton } from 'primeng/radiobutton';
import { MessageService } from 'primeng/api';
import { PickListModule } from 'primeng/picklist';
import { TableModule } from 'primeng/table';
import { Router } from '@angular/router';
import { InputNumber } from 'primeng/inputnumber';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { IconField } from 'primeng/iconfield';
import { InputIcon } from 'primeng/inputicon';
import { CheckboxModule } from 'primeng/checkbox';
import { AnoExperienciaEnum, EstadoVagaEnum, NivelHabilitacaoEnum, ProfissaoCatalogoListItemDTO, 
  ProfissaoCatalogoService, RegimeTrabalhoEnum, SectorEnum, TipoContratoEnum, Vaga, VagaService } from '../../../api';

@Component({
  selector: 'app-cadastrar-vagas',
  imports: [
    CommonModule, ReactiveFormsModule, Select, InputTextModule, ButtonModule, StepperModule, TableModule,
    InputIcon, DatePicker, CheckboxModule, FileUploadModule, IconField, RadioButton, PickListModule, InputNumber
  ],
  providers: [MessageService],
  templateUrl: './cadastrar-vagas.component.html',
  styleUrl: './cadastrar-vagas.component.scss'
})
export class CadastrarVagasComponent implements OnInit {

  router = inject(Router)
  ref = inject(DynamicDialogRef);
  concursoService = inject(VagaService);
  profissaoService = inject(ProfissaoCatalogoService);
  cdr = inject(ChangeDetectorRef);
  messageService = inject(MessageService);
  fb = inject(FormBuilder);
  concurso: Vaga | undefined | null;
  addConcursoForm: FormGroup = new FormGroup({});
  activeStep: number = 1;
  listaProfissoes: ProfissaoCatalogoListItemDTO[] = [];
  subsector = [
    { id: SectorEnum.NUMBER_1, designacao: "Petróleo e Gás" },
    { id: SectorEnum.NUMBER_2, designacao: "Recursos Minerais" },
  ]
  tipoContratoOptions = [
    { label: 'Termo certo', value: TipoContratoEnum.NUMBER_1 },
    { label: 'Termo incerto', value: TipoContratoEnum.NUMBER_2 },
    { label: 'Prestação de serviço', value: TipoContratoEnum.NUMBER_3 },
    { label: 'Trabalho temporário', value: TipoContratoEnum.NUMBER_4 },
    { label: 'Estágio remunerado', value: TipoContratoEnum.NUMBER_5 },
    { label: 'Estágio não remunerado', value: TipoContratoEnum.NUMBER_6 },
  ];

  nivelHabilitacaoOptions = [
    { value: NivelHabilitacaoEnum.NUMBER_1, label: "Ensino Primário" },
    { value: NivelHabilitacaoEnum.NUMBER_2, label: "1ºCiclo do Secundário" },
    { value: NivelHabilitacaoEnum.NUMBER_3, label: "Ensino Médio-2ºCiclo do Secundário" },
    { value: NivelHabilitacaoEnum.NUMBER_4, label: "Bacharelato" },
    { value: NivelHabilitacaoEnum.NUMBER_5, label: "Licenciatura" },
    { value: NivelHabilitacaoEnum.NUMBER_6, label: "Pós-Graduação" },
    { value: NivelHabilitacaoEnum.NUMBER_7, label: "Mestrado" },
    { value: NivelHabilitacaoEnum.NUMBER_8, label: "Doutoramento" },
    { value: NivelHabilitacaoEnum.NUMBER_9, label: "Pós-Doutoramento" },
  ];

  regimeTrabalhoOptions = [
    { label: 'Normal', value: RegimeTrabalhoEnum.NUMBER_1 },
    { label: 'Rotação Onshore', value: RegimeTrabalhoEnum.NUMBER_2 },
    { label: 'Rotação Offshore', value: RegimeTrabalhoEnum.NUMBER_3 },
    { label: 'Rotação Mista', value: RegimeTrabalhoEnum.NUMBER_3 },
  ];

  estadoVagaOptions = [
    { label: 'Aberta', value: EstadoVagaEnum.NUMBER_1 },
    { label: 'Encerrada', value: EstadoVagaEnum.NUMBER_2 },
  ];

  anosExperienciaOptions = [
    { value: AnoExperienciaEnum.NUMBER_1, label: "Sem experiência" },
    { value: AnoExperienciaEnum.NUMBER_2, label: "De 1 a 3 anos" },
    { value: AnoExperienciaEnum.NUMBER_3, label: "De 3 a 5 anos" },
    { value: AnoExperienciaEnum.NUMBER_4, label: "De 5 a 8 anos" },
    { value: AnoExperienciaEnum.NUMBER_5, label: "De 8 a 10 anos" },
    { value: AnoExperienciaEnum.NUMBER_6, label: "Mais de 10 anos" },
    { value: AnoExperienciaEnum.NUMBER_7, label: "mais de 15 anos" },
  ];


  constructor() {
  }

  ngOnInit(): void {
    this.createForm();
  }

  createForm() {
    this.addConcursoForm = this.fb.group({
      id: [0],
      empresaID: [0],
      profissaoCatalogoID: [0, Validators.required],
      codgoFuncao: [''],
      designacaoFuncao: [''],
      numVaga: [0, Validators.min(0)],
      tipoContrato: [1, Validators.required],
      nivelHabilitacao: [1, Validators.required],
      anoExperiencia: [1, Validators.min(0)],
      regimeTrabalho: [1, Validators.required],
      dataEncerramento: [null, Validators.required],
      descricao: [''],
      modelo: [''],
      localizacao: [''],
      estadoVaga: [1],
      remuneracao: [0],
      pAlvo: [''],
    });
  }

  public get profissaoSelecionada(): ProfissaoCatalogoListItemDTO | undefined {
    return this.listaProfissoes.find(x => x.id == this.addConcursoForm.value.profissaoCatalogoID)
  }

  prevStep() {
    if (this.activeStep === 1) {
      return;
    }
    this.activeStep--;
  }

  nextStep() {
    if (this.activeStep === 2) {
      this.save();
      return;
    }
    this.activeStep++;
  }

  onChangeSector(item: SelectChangeEvent) {
    let subSector = item.value as SectorEnum;
    this.listaProfissoes = [];
    this.addConcursoForm.patchValue({
      codigoISCO: undefined
    })
    this.profissaoService.getAllProfissaoCatalogoGet(undefined, undefined, undefined, undefined, undefined, subSector).subscribe(result => {
      if (result.data) {
        this.listaProfissoes = result.data;
        console.log(this.listaProfissoes)
      }
    })
  }

  get categoriasControls() {
    return (this.addConcursoForm.get('concursoCategorias') as FormArray).controls;
  }

  addCategoria() {
    const categoriaForm = this.addConcursoForm.get('categoriaForm') as FormGroup;
    const categorias = this.addConcursoForm.get('concursoCategorias') as FormArray;

    if (categoriaForm.valid) {
      categorias.push(this.fb.group(categoriaForm.value));
      categoriaForm.reset({
        nome: '',
        descricao: '',
        numVaga: 0
      });
    } else {
      categoriaForm.markAllAsTouched();
    }
  }

  removeCategoria(index: number) {
    const categorias = this.addConcursoForm.get('concursoCategorias') as FormArray;
    categorias.removeAt(index);
  }

  addFase(categoriaIndex: number) {
    const categorias = this.addConcursoForm.get('concursoCategorias') as FormArray;
    const fases = categorias.at(categoriaIndex).get('concursoCategoriaFases') as FormArray;
    fases.push(
      this.fb.group({
        faseID: [0],
        ordem: [0],
        dataInicio: [new Date(), Validators.required],
        dataFim: [new Date(), Validators.required],
      })
    );
  }

  removeFase(categoriaIndex: number, faseIndex: number) {
    const categorias = this.addConcursoForm.get('concursoCategorias') as FormArray;
    const fases = categorias.at(categoriaIndex).get('concursoCategoriaFases') as FormArray;
    fases.removeAt(faseIndex);
  }

  getConcurso(concursoId: number) {
    this.concursoService.getVagaByIdIdGet(concursoId).subscribe(concurso => {
      this.concurso = concurso.data;
      if (this.concurso) {
        this.addConcursoForm?.patchValue({
          ...this.concurso
        });
      }
    });
  }

  save() {
    if (this.addConcursoForm?.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Alerta', detail: 'Formulário inválido', life: 3000 });
      return;
    }
    this.concurso = {
      ...this.addConcursoForm?.value,
      empresaID: 2,
      codgoFuncao: this.profissaoSelecionada?.codigoISCO,
      designacaoFuncao: this.profissaoSelecionada?.designacaoISCO,
      estadoVaga: EstadoVagaEnum.NUMBER_1,
    } as Vaga;
    this.concursoService.addVagaPost(this.concurso).subscribe(result => {
      if (result.retorno?.codigo === 200) {
        this.messageService.add({ severity: 'info', summary: 'Info', detail: 'Concurso criado', life: 3000 });
        this.ref.close({ refresh: true });
        this.limpar();
      } else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Falha na criação do concurso criado', life: 3000 });
      }
    });
  }

  limpar() {
    this.addConcursoForm?.reset();
    this.concurso = null;
  }

  cancel() {
    this.ref.close(); // Close the dialog without saving
  }
}
